import posthog from 'posthog-js';
import * as Sentry from '@sentry/vue';
import type { App as VueApp } from 'vue';

let initialized = false;

export function initAnalytics(vueApp: VueApp): void {
  if (initialized) {
    return;
  }
  initialized = true;

  // --- Sentry ---
  const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
  if (sentryDsn) {
    Sentry.init({
      app: vueApp,
      dsn: sentryDsn,
      environment: import.meta.env.VITE_APP_ENV || 'development',
      release: import.meta.env.VITE_SENTRY_RELEASE || undefined,
      integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
      tracesSampleRate: 0.2,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
  }

  // --- PostHog ---
  const posthogKey = import.meta.env.VITE_POSTHOG_KEY;
  if (posthogKey) {
    posthog.init(posthogKey, {
      api_host: 'https://eu.i.posthog.com',
      autocapture: true,
      capture_pageview: true,
      capture_pageleave: true,
      enable_recording_console_log: false,
      opt_out_capturing_by_default: true,
      session_recording: {
        maskAllInputs: true,
        maskTextSelector: '.chat-scroll',
      },
    });
  }
}

export function track(event: string, properties?: Record<string, unknown>): void {
  if (posthog.__loaded) {
    posthog.capture(event, properties);
  }
}

export function identify(): void {
  if (posthog.__loaded) {
    const id = posthog.get_distinct_id();
    posthog.identify(id);
    Sentry.setUser({ id });
  }
}

export function optIn(): void {
  if (posthog.__loaded) {
    posthog.opt_in_capturing();
  }
}

export function optOut(): void {
  if (posthog.__loaded) {
    posthog.opt_out_capturing();
  }
}
